module.exports = __webpack_public_path__ + "img/system_4.7c9af3c7.png";